<template lang="pug">
    div( class="d-flex flex-column flex-grow-1 min-h-0 fill-height overflow-hidden"  )
        div( class=" tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pb-1 tw-text-left" )
            v-row
                v-col
                    span( class=" tw-text-2xl text-secondary tw-font-bold ") Add new listing
        div(class=" tw-flex tw-flex-row tw-flex-grow tw-p-4 tw-pl-2" )
            v-row(align-self="start" class=" tw-flex tw-flex-row tw-h-full tw-flex-grow tw-p-2 tw-pt-0")
                v-col(class="  tw-flex tw-flex-col tw-flex-grow")
                    v-form(
                        ref="form"
                        v-model="valid"
                        lazy-validation
                        @keyup.native.enter="valid && submit($event)"
                    )

                    v-tabs(vertical)
                        v-tab()
                            span() Description
                        v-tab()
                            span() Location
                        v-tab()
                            span() Offering

                    
                        v-tab-item(transition="fade-transition" reverse-transition="fade-transition" eager)
                            v-container( fluid class="tw-px-6" )
                                v-row
                                    v-col
                                        v-row(no-gutters)
                                            v-col
                                                v-text-field(
                                                    v-model="name"
                                                    label="Ad title"
                                                    :rules="nameRules"
                                                    color="blue darken-4"
                                                    required
                                                )
                                        v-row(no-gutters)
                                            v-col
                                                v-textarea(
                                                    v-model="description"
                                                    label="Description"
                                                    :rules="descriptionRules"
                                                    color="blue darken-4"
                                                    required
                                                )
                                        v-row()
                                            v-col
                                                v-select(
                                                    v-model="listingType"
                                                    label="Listing Type"
                                                    :items="listingTypes"
                                                )
                                            v-col
                                                v-text-field(
                                                    v-model="yearBuilt"
                                                    label="Year Built"
                                                )
                                            
                                        v-row
                                            v-col
                                                v-text-field(
                                                    v-model="constructionSize"
                                                    label="Construction size"
                                                )
                                            v-col
                                                v-text-field(
                                                    v-model="plotSize"
                                                    label="Lot size "
                                                )
                                                    
                                                    
                                                
                                    v-col
                                        v-row(justify="space-around")
                                            v-col(cols="auto")
                                                v-select( 
                                                    v-model="bedrooms"
                                                    label="Bedrooms"
                                                    :items="quantity"
                                                )
                                                    
                                            v-col(cols="auto")
                                                v-select( 
                                                    v-model="bathrooms"
                                                    label="Bathrooms"
                                                    :items="quantity"
                                                )
                                        v-row(justify="space-around")
                                            v-col(cols="auto")
                                                v-select( 
                                                    v-model="parking"
                                                    label="Parking spaces"
                                                    :items="quantity"
                                                )
                                                    
                                            v-col(cols="auto")
                                                v-select( 
                                                    v-model="floors"
                                                    label="Floors"
                                                    :items="quantity"
                                                )
                                                    
                                                                    
                                    
                        v-tab-item(transition="fade-transition" reverse-transition="fade-transition" eager)
                            v-container( fluid class="tw-px-6" )
                                v-row
                                    v-col(cols="7")
                                        //- GmapAutocomplete( 
                                        //-     placeholder="This is a placeholder text"
                                        //-     selectFirstOnEnter
                                        //-     @place_changed="setAddress"
                                        //- )
                                        v-row
                                            v-col
                                                gmap-autocomplete(
                                                    v-model="address"
                                                    class="IntroInput"
                                                    selectFirstOnEnter
                                                    @place_changed="setAddress"
                                                )
                                                    template(v-slot:input="slotProps")
                                                        v-text-field(
                                                            v-model="address"
                                                            placeholder="Type the address for this listing"
                                                            ref="input"
                                                            v-on:listeners="slotProps.listeners"
                                                        )
                                        v-row
                                            v-col(cols="9")
                                                v-text-field(
                                                    v-model="addressStreet"
                                                    disabled
                                                    outlined
                                                    hide-details
                                                    label = "Street"
                                                )
                                            v-col(cols="3")
                                                v-text-field(
                                                    v-model="addressNumber"
                                                    disabled
                                                    outlined
                                                    hide-details
                                                    label = "Number"
                                                )
                                        v-row(v-if="addressExtend"  class="tw-py-0 tw-my-0")
                                            v-col
                                                v-text-field(
                                                    v-model="addressExtend"
                                                    disabled
                                                    outlined
                                                    hide-details
                                                    label = "Extended Address"
                                                )
                                        
                                        v-row
                                            v-col
                                                v-text-field(
                                                    v-model="addressCity"
                                                    disabled
                                                    outlined
                                                    hide-details
                                                    label = "City"
                                                )
                                            
                                            v-col
                                                v-text-field(
                                                    v-model="addressState"
                                                    disabled
                                                    outlined
                                                    hide-details
                                                    label = "State"
                                                )
                                        
                                        v-row
                                            v-col
                                                v-text-field(
                                                    v-model="addressCountry"
                                                    disabled
                                                    outlined
                                                    hide-details
                                                    label = "Country"
                                                )
                                            
                                            v-col
                                                v-text-field(
                                                    v-model="addressZipCode"
                                                    disabled
                                                    outlined
                                                    hide-details
                                                    label = "Zip Code"
                                                )
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                    v-col(cols="5")
                                        kubiqa-misc-map(:key="key" mapHeight="420px" :position="position"  )
                        v-tab-item(transition="fade-transition" reverse-transition="fade-transition" eager)
                            v-container( fluid )
                                v-row( class="")
                                    v-col
                                        v-row
                                            v-col
                                                v-checkbox(
                                                    v-model="enableSell"
                                                    label="Sell"
                                                )
                                                    

                                    v-col( class="")
                                        v-row
                                            v-col
                                                v-checkbox(
                                                    v-model="rentEnable"
                                                    label="Rent"
                                                )
                                                    
                                            
                                        
        div(class="tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pt-1")
            v-row(justify="end" align-self="end" align="end" class="tw-bottom-0")
                v-col(cols="auto" class="tw-h-full fill-height")
                    v-btn( depressed color="rgba(94,129,244,0.80)" :loading="loading" @click="submit"  ) 
                                span(class="tw-font-bold" ) Save
        

</template>
<script>
    export default {
        data(){
            return{
                valid: true,
                loading: false,
                name:'',
                description:'',
                listingType:'',
                yearBuilt:'',
                constructionSize:'',
                plotSize:'',
                bedrooms:'',
                bathrooms:'',
                parking:'',
                floors: '',


                address: '',
                addressNumber: '',
                addressStreet: '',
                addressExtend: '',
                addressCity: '',
                addressState: '',
                addressCountry: '',
                addressZipCode: '',

                enableSell: '',
                rentEnable: '',

                position: {},
                key: 1,

                listingTypes:[
                    'House', 'Appartment', 'Office Space', 'Plot' 
                ],
                quantity:[
                    '1', '2', '3', '4', '5+'
                ],
                nameRules: [
                    v => !!v || 'Please enter a title for this listing'  
                ],
                descriptionRules: [
                    v => !!v || 'Please enter a title for this listing'  
                ]
            }
        },
        methods: {
            save(){
                console.log(this.form)
            },
            validate() {
                if (this.$refs.form.validate()) {
                    this.error = true;
                    this.error_message = 'error'
                }
            },
            resetValidation() {
                this.$refs.form.resetValidation();
            },
            setAddress(address){
                this.addressNumber = '',
                this.addressStreet = '',
                this.addressExtend = '',
                this.addressCity = '',
                this.addressState = '',
                this.addressCountry = '',
                this.addressZipCode = '',
                this.address = address.formatted_address
                this.key += this.key
                this.position.lat = address.geometry.location.lat()
                this.position.lng = address.geometry.location.lng() 
                for (let i = 0; i < address.address_components.length; i++) {
                    const componentType = address.address_components[i].types[0]
                    switch (componentType) {
                        
                    case "street_number":
                        this.addressNumber = address.address_components[i].long_name
                        break
                    
                    case "route":
                        this.addressStreet = address.address_components[i].long_name
                        break
                    
                    case "sublocality_level_1":
                        this.addressExtend = address.address_components[i].long_name
                        break
 
                    case "locality":
                        this.addressCity = address.address_components[i].long_name
                        break
                    
                    case "administrative_area_level_1":
                        this.addressState = address.address_components[i].long_name
                        break
                        
                    case "country":
                        this.addressCountry = address.address_components[i].long_name
                        break
                        
                    case "postal_code":
                        this.addressZipCode = address.address_components[i].long_name
                        break
                    }
                } 

            },
            refresh(){
                this.key += this.key
            },
            submit() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    this.$store.dispatch('properties/addProperty', {
                        name: this.name, 
                    })
                        .then(response => {
                            this.$store.dispatch('properties/getProperties')
                            this.$store.getters['properties/properties']
                            this.$emit('close')
                            this.loading = false
                            this.$refs.form.reset()
                        })
                
                        .catch(error => {
                            this.error = true;
                            console.log(this.$store.state.error)
                            this.error_message = this.$store.state.error;
                        });
                }
            }

        },
    }
</script>